{{#if (and iterationPropertiesList (not iterationPropertiesList.previous))}}
foreach ({{#if isPolicy}}object.{{/if}}{{ variable.identifier }}[{{#each iterationPropertiesList.last.iterationVariables delimeter=", "}}{{ . }}{{/each}}]) {
  {{> (partial "snippets/num-transactions-constraint") variable=variable iterationPropertiesList=iterationPropertiesList.next isPolicy=isPolicy condition=condition}}
}
{{else}}
{{#with variable}}
{{#if ../isPolicy}}object.{{/if}}{{ identifier }}{{ iterationPropertiesList.last.brackets }} {{ ../condition }};
{{/with}}
{{/if}}
